export default __webpack_public_path__ + "static/media/fondo_snacks.7431570d.jpg";